import MerchantEvaluationProjectApi from '@/api/merchant-evaluation-project'

/**
 * 评审系统 - 评审方案管理
 */

const state = {}

const mutations = {}

const actions = {
  async list ({ commit }, params) {
    const result = await MerchantEvaluationProjectApi.list(params)
    return result
  },
  async summary ({ commit }, params) {
    const result = await MerchantEvaluationProjectApi.summary(params)
    return result
  },
  async getById ({ commit }, id) {
    const result = await MerchantEvaluationProjectApi.getById(id)
    return result
  },
  async insert ({ commit }, data) {
    const result = await MerchantEvaluationProjectApi.insert(data)
    return result
  },
  async batchInsert ({ commit }, data) {
    const result = await MerchantEvaluationProjectApi.batchInsert(data)
    return result
  },
  // async update ({ commit }, data) {
  //   const result = await MerchantEvaluationProjectApi.update(data)
  //   return result
  // },
  async remove ({ commit }, id) {
    const result = await MerchantEvaluationProjectApi.remove(id)
    return result
  },
  async updateFinishStatus ({ commit }, data) {
    const result = await MerchantEvaluationProjectApi.updateFinishStatus(data)
    return result
  },
  async getSchemeConfigs ({ commit }) {
    const result = await MerchantEvaluationProjectApi.getSchemeConfigs()
    return result
  },
  async getSchemeItemConfigs ({ commit }, params) {
    const result = await MerchantEvaluationProjectApi.getSchemeItemConfigs(params)
    return result
  },
  async getJudges ({ commit }) {
    const result = await MerchantEvaluationProjectApi.getJudges()
    return result
  },
  async getProjectJudges ({ commit }, id) {
    const result = await MerchantEvaluationProjectApi.getProjectJudges(id)
    return result
  },
  async batchSaveProjectJudges ({ commit }, data) {
    const result = await MerchantEvaluationProjectApi.batchSaveProjectJudges(data)
    return result
  },
  async getEntryValueEvals ({ commit }, params) {
    const result = await MerchantEvaluationProjectApi.getEntryValueEvals(params)
    return result
  },
  async getEntryValueRankIds ({ commit }, params) {
    const result = await MerchantEvaluationProjectApi.getEntryValueRankIds(params)
    return result
  },
  async releaseRank ({ commit }, params) {
    const result = await MerchantEvaluationProjectApi.releaseRank(params)
    return result
  },
  async cancelRank ({ commit }, params) {
    const result = await MerchantEvaluationProjectApi.cancelRank(params)
    return result
  },
  async getEntryValueRanks ({ commit }, params) {
    const result = await MerchantEvaluationProjectApi.getEntryValueRanks(params)
    return result
  },
  async getEntryValueDetail ({ commit }, params) {
    const result = await MerchantEvaluationProjectApi.getEntryValueDetail(params)
    return result
  },
  async submitEvals ({ commit }, data) {
    const result = await MerchantEvaluationProjectApi.submitEvals(data)
    return result
  },
  async finishEntryValueEval ({ commit }, data) {
    const result = await MerchantEvaluationProjectApi.finishEntryValueEval(data)
    return result
  },
  async promoteEntryValue ({ commit }, data) {
    const result = await MerchantEvaluationProjectApi.promoteEntryValue(data)
    return result
  },
  async siftedOutEntryValue ({ commit }, data) {
    const result = await MerchantEvaluationProjectApi.siftedOutEntryValue(data)
    return result
  },
  async getEntryValueEvalItemValues ({ commit }, params) {
    const result = await MerchantEvaluationProjectApi.getEntryValueEvalItemValues(params)
    return result
  },
  async exportEvalResult ({ commit }, params) {
    const result = await MerchantEvaluationProjectApi.exportEvalResult(params)
    return result
  },
  async exportEvalResult2 ({ commit }, params) {
    const result = await MerchantEvaluationProjectApi.exportEvalResult2(params)
    return result
  },
  async createExportEntryPdfTask ({ commit }, { projectId, body }) {
    const result = await MerchantEvaluationProjectApi.createExportEntryPdfTask(projectId, body)
    return result
  },
  async getExportEntryPdfTaskDownloadUrl (ctx, { projectId, taskId }) {
    return MerchantEvaluationProjectApi.getExportEntryPdfTaskDownloadUrl(projectId, taskId)
  },
  /** 取消排队中的 PDF 导出任务（PENDING → CANCELLED），参数须与任务 evalProjectId / id 一致 */
  async cancelExportEntryPdfTask (ctx, { projectId, taskId }) {
    return MerchantEvaluationProjectApi.cancelExportEntryPdfTask(projectId, taskId)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/merchant-evaluation-project.js